import request from '@/lib/request';
import { userTypeAll } from '@/enum/index';
const userType = userTypeAll.getKeyByValue('患者端');

export function mallOrderLogistics(mallOrderId) {
  return request.get(`/mall/mallOrderLogistics/${mallOrderId}`);
}

export function userPoints() {
  return request.get(`/mall/userPoints/info`);
}

export function recommend() {
  return request.get(`/mall/index/drugs/recommend`);
}

export function discount() {
  return request.get(`/mall/index/drugs/discount`);
}

export function imported() {
  return request.get(`/mall/index/drugs/imported`);
}

export function clinicCategory() {
  return request.get(`/mall/drugs/clinicCategory`);
}

export function categoryDrugs(categoryId, params) {
  return request.get(`/mall/drugs/categoryDrugs/${categoryId}`, {
    params
  });
}

export function mallCart() {
  return request.get(`/mall/mallCart/list`);
}

export function addMallCart(params) {
  return request.post(`/mall/mallCart`, params);
}

export function mealDetail(drugsId) {
  return request.get(`/mall/drugs/drugsInfo/${drugsId}`);
}

export function userPointsFlowList(params) {
  return request.get(`/mall/userPoints/flowList`, {
    params
  });
}

export function userPointsCardList(params) {
  return request.get(`/mall/userPoints/list`, {
    params
  });
}

export function deleteMall(mallCartIds) {
  return request.delete(`/mall/mallCart/${mallCartIds}`);
}

export function queryClinicDrugs(params) {
  return request.get(`/mall/drugs/queryClinicDrugs`, {
    params
  });
}

export function cancelOrder(mallOrderId) {
  return request.delete(`/mall/mallOrder/${mallOrderId}`);
}

export function sendSms(mobile) {
  return request.get(`/auth/userlogin/sms/${mobile}/${userType}`);
}

export function smsLogin(params) {
  return request.post(`/auth/userlogin/smslogin`, {
    ...params,
    userType
  });
}

export function calculatePrice(params) {
  return request.post('/mall/mallOrder/calculatePrice', params);
}

export function userLogin(params) {
  return request.post('/user/login', params);
}

export function getClinicList(params) {
  return request.get(`/mall/clinic/list`, {
    params
  });
}

export function getDevelopClinicList(params) {
  return request.get(`/mall/clinic/developing`, {
    params
  });
}

export function getBindClinicList(params) {
  return request.get(`/mall/clinic/allClinic`, {
    params
  });
}

export function getDeviceList() {
  return request.get(`/mall/clinic/device/rel/listAllDevices`);
}

export function bindClinicDevice(params) {
  return request.post(`/mall/clinic/device/rel/bindClinicDevice`, params);
}

export function clinicAdd(params) {
  return request.put(`/mall/clinic/add`, params);
}

export function getMyTeam(params) {
  return request.get(`/mall/sales/myTeam`, {
    params
  });
}

export function getSalesInfo(id) {
  return request.get(`/mall/sales/${id}`);
}

export function editSalesInfo(params) {
  return request.put(`/mall/sales`, params);
}

export function addSalesInfo(params) {
  return request.post(`/mall/sales`, params);
}

export function addSalesInvite(params) {
  return request.post(`/mall/sales/invite`, params);
}

export function getMallInfo() {
  return request.get(`/mall/user/getInfo`);
}

export function changeAvatar(params) {
  return request.post(`/mall/user/avatar?avatar=${params.avatar}`);
}

export function getPartnerScore() {
  return request.get(`/mall/index/score`);
}

export function getRankClinic(params) {
  return request.get(`/mall/index/rank/clinic`, {
    params
  });
}

export function getRankSales() {
  return request.get(`/mall/index/rank/sales`);
}

export function salesDeviceList(params) {
  return request.get(`/mall/clinic/device/rel/salesDeviceList`, {
    params
  });
}

export function getClinicInfo(id) {
  return request.get(`/mall/clinic/getInfo/${id}`);
}

export function getDevelopingClinicInfo(hisId) {
  return request.get(`/mall/clinic/developing/${hisId}`);
}

export function delClinicDevice(id) {
  return request.delete(`/mall/clinic/device/rel/delClinicDevice/${id}`);
}

export function changeClinicDevices(params) {
  return request.post(`/mall/clinic/device/rel/changeClinicDevices`, params);
}

export function clinicWithinRange(params) {
  return request.get(`/mall/clinic/withinRange`, {
    params
  });
}

export function salesSignin(params) {
  return request.get(`/mall/clinic/salesSignin`, {
    params
  });
}

export function getOverview(params) {
  return request.get(`/mall/user/overview/`, {
    params
  });
}

export function getSalesBill(params) {
  return request.get(`/mall/bill/sales/list`, {
    params
  });
}

export function getSalesBillDetails(params) {
  return request.get(`/mall/bill/sales/details`, {
    params
  });
}

export function getClinicScore(id) {
  return request.get(`/mall/clinic/score/${id}`);
}

export function getClinicSales(id) {
  return request.get(`/mall/clinic/getSales/${id}`);
}

export function getDeviceInfo(clinicDeviceRelId) {
  return request.get(`/mall/clinic/device/rel/${clinicDeviceRelId}`);
}

export function getOneClinicServiceOrderList(params) {
  return request.get(`/mall/mallOrder/getOneClinicServiceOrderList`, {
    params
  });
}

export function getOneSalesToDoServiceOrders(params) {
  return request.get(`/mall/mallOrder/getOneSalesToDoServiceOrders`, {
    params
  });
}

export function clinicDevelopingEdit(params) {
  return request.post(`/mall/clinic/developing/edit`, params);
}

export function clinicDevelopingAdd(params) {
  return request.post(`/mall/clinic/developing/add`, params);
}

export function mealListService() {
  return request.get('/mall/meal/listService');
}

export function wxPay(params) {
  return request.post(`/mall/mallOrder/wxPay`, params);
}

export function createServiceOrder(params) {
  return request.post('/mall/mallOrder/createMallOrder', params);
}

export function orderList(params) {
  return request.get(`/mall/mallOrder/list`, {
    params
  });
}

export function getServiceOrder(mallOrderId) {
  return request.get(`/mall/mallOrder/${mallOrderId}`);
}

export function orderBindClinic(params) {
  return request.post(`/mall/mallOrder/bindClinic`, params);
}

export function orderBindExport(params) {
  return request.post(
    `/mall/bill/sales/export?billId=${params.billId}`,
    {},
    {
      responseType: 'blob'
    }
  );
}

export function getAddressList(params) {
  return request.get(`/mall/address/list`, {
    params
  });
}
export function addAddress(params) {
  return request.post(`/mall/address`, params);
}

export function editAddress(params) {
  return request.put(`/mall/address`, params);
}

export function getAddress(id) {
  return request.get(`/mall/address/${id}`);
}

export function deleteAddress(id) {
  return request.delete(`/mall/address/${id}`);
}

export function createFeedback(params) {
  return request.post(`/mall/feedback`, params);
}

export function getClinicDeviceStock(clinicId) {
  return request.get(`/mall/clinic/stock/getClinicDeviceStock/${clinicId}`);
}

export function getPerformanceList(params) {
  return request.get(`/mall/performance/list`, {
    params
  });
}

export function reduceOrderInventory(params) {
  return request.post(`/mall/mallOrder/reduceOrderInventory`, params);
}

export function stockSalesList(params) {
  return request.get(`/mall/stockSales/list`, {
    params
  });
}

export function listDeviceStockSales(params) {
  return request.get(`/mall/stockSales/listDeviceStockSales`, {
    params
  });
}

export function transferSalesStock(params) {
  return request.post(`/mall/stockSales/transferSalesStock`, params);
}

export function salesStockRecord(params) {
  return request.get(`/mall/salesStockRecord/list`, {
    params
  });
}

export function addDeviceApplyRecord(params) {
  return request.post(`/mall/deviceApplyRecord`, params);
}

export function deviceApplyRecordList(params) {
  return request.get(`/mall/deviceApplyRecord/list`, {
    params
  });
}

export function getSalesDevices(params) {
  return request.get(`/mall/clinic/device/rel/getSalesDevices`, {
    params
  });
}

export function deviceRecord(params) {
  return request.post(`/mall/deviceRecord`, params);
}

export function performanceListSummary(params) {
  return request.get(`/mall/performance/listSummary`, params);
}

export function contractList(params) {
  return request.get(`/mall/contract/list/clinic`, params);
}

export function contractListClinic(params) {
  return request.get(`/mall/contract/list/clinic/sign`, {
    params
  });
}

export function contractApply(params) {
  return request.post(`/mall/contract/apply`, params);
}

export function getPatientRelList(params) {
  return request({
    url: '/mall/patientrel/list',
    method: 'get',
    params
  });
}

export function deletePatientRel(patientRelId) {
  return request({
    url: `/mall/patientrel/${patientRelId}`,
    method: 'delete'
  });
}

export function patientrelAdd(params) {
  return request.post(`/mall/patientrel/add`, params);
}

export function patientrelEdit(params) {
  return request.post(`/mall/patientrel/edit`, params);
}

export function patientrelDetail(patientRelId) {
  return request.get(`/mall/patientrel/${patientRelId}`);
}

// export function diseaseList(params) {
//   return request.get(`/mall/disease/list`, { params });
// }

export function diseaseList(params) {
  return request.post(`/mall/disease/list`, params);
}

export function rxInquiry(params) {
  return request.post(`/mall/rx/inquiry`, params);
}

export function rxInfo(orderId) {
  return request.get(`/mall/rx/info/${orderId}`);
}

export function getNav() {
  return request.get(`/mall/index/nav`);
}

export function getDrugsNav(navId, params) {
  return request.get(`/mall/drugs/nav/${navId}`, {
    params
  });
}

export function getChangeClinicList(params) {
  return request.get(`/mall/index/clinic/list`, {
    params
  });
}

export function getIndexZone(params) {
  return request.get(`/mall/index/indexZone`, {
    params
  });
}

export function getZoneTypeMall(zoneType) {
  return request.get(`/mall/index/indexZone/${zoneType}`);
}
